import HEAD from '@/components/Head.vue'
import NAVMENU from '@/components/Home.vue';
import TagsView from '@/components/TagsView';
import FButton from '@/components/FButton';
import SearchForm from '@/components/SearchForm';
import SearchFormWrap from '@/components/SearchFormWrap';
import ToolBar from "@/components/TableToolBar/index";
import TButton from "@/components/TableToolBar/TButton";
import FSingleImageUpload from "@/components/FSingleImageUpload";
import OperatorSelectById from "@/components/PropsSelect/OperatorSelectById";
import FPanel from '@/components/FPanel';

import OperatorSelectByName from "@/components/PropsSelect/OperatorSelectByName";
import PageWrapper from "@/components/PageWrapper/index";
import Operator from "@/components/operation/Operator";
import SitePoint from "@/components/operation/SitePoint";
import dishuOperator from "@/components/operation/dishuOperator";
import supplierSelect from "@/components/supplierSelect";
import batchSelect from "@/components/batchSelect";
import orderNumber from "@/components/operation/orderNumber";
import MultipleFactory from "@/components/operation/MultipleFactory";  //多选厂家
import Factory from "@/components/operation/factory";  //多选厂家
import I18nFormItem from "@/components/I18n/I18nFormItem.vue";  //多选厂家
import I18nTableColumn from "@/components/I18n/I18nTableColumn.vue";  //多选厂家
export default {
  install: function (Vue) {
    Vue.component('public-head', HEAD)
    Vue.component('public-nav', NAVMENU)
    Vue.component('tags-view', TagsView)
    Vue.component('f-button', FButton)
    Vue.component('search-from', SearchForm)
    Vue.component('search-from-wrap', SearchFormWrap)
    Vue.component('tool-bar', ToolBar)
    Vue.component('t-button', TButton)
    Vue.component('f-single-image-upload', FSingleImageUpload)
    Vue.component('operator-select', OperatorSelectById)
    Vue.component('operator-select-name', OperatorSelectByName)
    Vue.component('page-wrapper',PageWrapper)
    Vue.component('f-panel',FPanel)
    Vue.component('operator',Operator)
    Vue.component('SitePoint',SitePoint)
    Vue.component('dishuOperator',dishuOperator)
    Vue.component('supplierSelect',supplierSelect)
    Vue.component('batchSelect',batchSelect)
    Vue.component('orderNumber',orderNumber)
    Vue.component('multiple-factory',MultipleFactory)
    Vue.component('Factory',Factory);
    Vue.component('I18nFormItem',I18nFormItem);
    Vue.component('I18nTableColumn',I18nTableColumn);
  }
}



// WEBPACK FOOTER //
// ./src/components/index.js